import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=608c0672&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('608c0672')) {
      api.createRecord('608c0672', component.options)
    } else {
      api.reload('608c0672', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=608c0672&", function () {
      api.rerender('608c0672', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20f4MZMZR9awa/JS/comp/IncreaseNumber.vue"
export default component.exports